import mixpanel from "mixpanel-browser";

const useAIBundleMixpanelHook = () => {
    function trackGetAIBundle({
        cta = "Get AI Bundle Suggestions",
        ctaType = "",
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
        };
        console._log("AIBundle: Get AI Bundle Suggestions", temp);
        mixpanel.track("AI - Get AI Bundle Suggestions", temp);
    }

    function trackSave({
        cta = "Save",
        ctaType = "",
        bundleIds = [],
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Save CTA", temp);
        mixpanel.track("AI - Save", temp);
    }

    function trackPublish({
        cta = "Publish",
        ctaType = "",
        bundleIds = [],
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Publish CTA", temp);
        mixpanel.track("AI - Publish", temp);
    }
    function trackPreview({
        cta = "Preview",
        ctaType = "",
        bundleIds = [],
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Preview CTA", temp);
        mixpanel.track("AI - Preview", temp);
    }
    function trackEdit({
        cta = "Edit",
        ctaType = "",
        bundleIds = [],
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Edit CTA", temp);
        mixpanel.track("AI - Edit", temp);
    }
    function trackDelete({
        cta = "Delete",
        ctaType = "",
        bundleIds = [],
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            "Cta Type": ctaType || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Delete CTA", temp);
        mixpanel.track("AI - Delete", temp);
    }
    function trackOpenInNewTab({
        cta = "Open in new tab",
        bundleIds = [],
    }: {
        cta?: string;
        ctaType?: string;
        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Open New Tab", temp);
        mixpanel.track("AI - Open New Tab", temp);
    }

    function trackClose({
        cta = "Close Modal",
        bundleIds = [],
    }: {
        cta?: string;

        bundleIds?: string[];
    }) {
        const temp = {
            Cta: cta || "-",
            BundleIds: bundleIds.length ? bundleIds : [],
        };
        console._log("AIBundle: Close Modal", temp);
        mixpanel.track("AI - Close Modal", temp);
    }

    function trackNewSuggestion({ cta = "Create New Suggestions", ctaType = "" }: { cta?: string; ctaType?: string }) {
        const temp = {
            Cta: cta || "-",
            ctaType: ctaType || "-",
        };
        console._log("AIBundle: Close Modal", temp);
        mixpanel.track("AI - Create New Suggestions", temp);
    }

    return {
        trackGetAIBundle,
        trackOpenInNewTab,
        trackClose,
        trackSave,
        trackPreview,
        trackPublish,
        trackEdit,
        trackDelete,
        trackNewSuggestion,
    };
};

export default useAIBundleMixpanelHook;
